import { toast } from '@side/pantry';
import { useEffect, useRef } from 'react';
import { useDelayedToast } from './DelayedToast.helpers';

export const DelayedToast = () => {
  const [toastConfig, setToastConfig] = useDelayedToast();
  const hasShownToast = useRef(false);

  useEffect(() => {
    if (toastConfig && !hasShownToast.current) {
      hasShownToast.current = true;
      toast(...toastConfig);
      setToastConfig(null);
    }
  }, [toastConfig, setToastConfig]);

  return null;
};
